import script from "./VDateFieldV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./VDateFieldV2.vue?vue&type=script&setup=true&lang=ts"

import "./VDateFieldV2.vue?vue&type=style&index=0&id=66d66d01&lang=css"

const __exports__ = script;

export default __exports__